import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/users/user6.jpg'


const _hoisted_1 = { class: "min-h-screen bg-white dark:bg-gradient-to-br dark:from-[#0c1427] dark:to-[#1a2332]" }
const _hoisted_2 = { class: "px-4 sm:px-6 lg:px-8 pt-6 pb-4" }
const _hoisted_3 = { class: "bg-white dark:bg-white/10 backdrop-blur-[20px] shadow-[0_8px_32px_0_rgba(31,38,135,0.15)] rounded-2xl p-6 border border-gray-100 dark:border-white/10" }
const _hoisted_4 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" }
const _hoisted_5 = { class: "text-2xl font-bold bg-gradient-to-r from-[#007AFF] to-[#5856D6] bg-clip-text text-transparent" }
const _hoisted_6 = { class: "text-sm text-[#8e8e93] dark:text-gray-400 mt-1" }
const _hoisted_7 = { class: "flex items-center gap-3" }
const _hoisted_8 = { class: "px-4 sm:px-6 lg:px-8 pb-4" }
const _hoisted_9 = { class: "bg-white dark:bg-white/10 backdrop-blur-[20px] shadow-[0_8px_32px_0_rgba(31,38,135,0.15)] rounded-2xl p-6 border border-gray-100 dark:border-white/10" }
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "px-4 sm:px-6 lg:px-8 pb-8" }
const _hoisted_13 = { class: "bg-white dark:bg-white/10 backdrop-blur-[20px] shadow-[0_20px_40px_0_rgba(0,0,0,0.1)] rounded-3xl overflow-hidden border border-gray-100 dark:border-white/10" }
const _hoisted_14 = {
  key: 0,
  class: "flex justify-center items-center py-20"
}
const _hoisted_15 = {
  key: 1,
  class: "p-8 text-center"
}
const _hoisted_16 = { class: "text-[#FF3B30] font-medium" }
const _hoisted_17 = {
  key: 2,
  class: "text-center py-20"
}
const _hoisted_18 = { class: "text-base font-medium text-[#1d1d1f] dark:text-white" }
const _hoisted_19 = { class: "text-sm mt-1 text-[#8e8e93] dark:text-gray-400" }
const _hoisted_20 = {
  key: 3,
  class: "overflow-x-auto"
}
const _hoisted_21 = { class: "w-full" }
const _hoisted_22 = { style: {"background":"linear-gradient(135deg, #667eea 0%, #764ba2 100%)"} }
const _hoisted_23 = { class: "px-6 py-4 text-left text-xs font-semibold text-white uppercase tracking-wider" }
const _hoisted_24 = { class: "px-6 py-4 text-left text-xs font-semibold text-white uppercase tracking-wider" }
const _hoisted_25 = { class: "px-6 py-4 text-left text-xs font-semibold text-white uppercase tracking-wider" }
const _hoisted_26 = { class: "px-6 py-4 text-left text-xs font-semibold text-white uppercase tracking-wider" }
const _hoisted_27 = { class: "px-6 py-4 text-left text-xs font-semibold text-white uppercase tracking-wider" }
const _hoisted_28 = { class: "px-6 py-4 text-left text-xs font-semibold text-white uppercase tracking-wider" }
const _hoisted_29 = { class: "px-6 py-4 text-left text-xs font-semibold text-white uppercase tracking-wider" }
const _hoisted_30 = { class: "px-6 py-4 text-center text-xs font-semibold text-white uppercase tracking-wider" }
const _hoisted_31 = { class: "divide-y divide-gray-100 dark:divide-white/10" }
const _hoisted_32 = { class: "px-6 py-4 whitespace-nowrap text-sm text-[#8e8e93] dark:text-gray-400" }
const _hoisted_33 = { class: "font-mono" }
const _hoisted_34 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_35 = { class: "flex items-center gap-3" }
const _hoisted_36 = { class: "text-sm font-medium text-[#1d1d1f] dark:text-white" }
const _hoisted_37 = { class: "text-xs text-[#8e8e93] dark:text-gray-400" }
const _hoisted_38 = { class: "px-6 py-4 whitespace-nowrap text-sm text-[#3c3c43] dark:text-gray-300" }
const _hoisted_39 = { class: "px-6 py-4 whitespace-nowrap text-sm text-[#3c3c43] dark:text-gray-300" }
const _hoisted_40 = { class: "px-6 py-4 whitespace-nowrap text-sm text-[#3c3c43] dark:text-gray-300" }
const _hoisted_41 = { class: "px-6 py-4 whitespace-nowrap text-sm text-[#3c3c43] dark:text-gray-300" }
const _hoisted_42 = { class: "flex items-center gap-2" }
const _hoisted_43 = { class: "px-6 py-4 whitespace-nowrap text-sm text-[#3c3c43] dark:text-gray-300" }
const _hoisted_44 = { class: "px-3 py-1 rounded-full bg-[#007AFF]/20 text-[#007AFF] font-medium" }
const _hoisted_45 = { class: "px-6 py-4 whitespace-nowrap text-center" }
const _hoisted_46 = { class: "flex items-center justify-center gap-2" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50 px-4"
}
const _hoisted_51 = { class: "relative transform transition-all duration-300 scale-100 bg-white dark:bg-gray-900/95 backdrop-blur-[20px] shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25)] rounded-3xl p-8 w-full max-w-lg max-h-[90vh] overflow-y-auto mt-[100px] sm:mt-0" }
const _hoisted_52 = { class: "flex justify-between items-center mb-6" }
const _hoisted_53 = { class: "text-2xl font-semibold text-[#1d1d1f] dark:text-white" }
const _hoisted_54 = {
  key: 0,
  class: "mb-4 p-4 bg-[#FFE5E5] dark:bg-red-500/20 rounded-2xl"
}
const _hoisted_55 = { class: "text-[#FF3B30] font-medium" }
const _hoisted_56 = { class: "space-y-4" }
const _hoisted_57 = { class: "block text-sm font-medium text-[#3c3c43] dark:text-gray-300 mb-2" }
const _hoisted_58 = { class: "block text-sm font-medium text-[#3c3c43] dark:text-gray-300 mb-2" }
const _hoisted_59 = { class: "block text-sm font-medium text-[#3c3c43] dark:text-gray-300 mb-2" }
const _hoisted_60 = { class: "block text-sm font-medium text-[#3c3c43] dark:text-gray-300 mb-2" }
const _hoisted_61 = { value: "superadmin" }
const _hoisted_62 = { value: "admin" }
const _hoisted_63 = { value: "editor" }
const _hoisted_64 = { value: "member" }
const _hoisted_65 = { value: "viewer" }
const _hoisted_66 = { class: "block text-sm font-medium text-[#3c3c43] dark:text-gray-300 mb-2" }
const _hoisted_67 = {
  key: 0,
  class: "text-center p-4"
}
const _hoisted_68 = { class: "text-[#8e8e93] dark:text-gray-400 mt-2" }
const _hoisted_69 = {
  key: 1,
  class: "p-4 bg-[#FFE5E5] dark:bg-red-500/20 rounded-xl"
}
const _hoisted_70 = { class: "text-[#FF3B30]" }
const _hoisted_71 = {
  key: 2,
  class: "max-h-60 overflow-y-auto border border-[#e5e5ea] dark:border-white/10 rounded-xl p-4 bg-white dark:bg-white/5"
}
const _hoisted_72 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_73 = ["id", "onUpdate:modelValue"]
const _hoisted_74 = ["for"]
const _hoisted_75 = { class: "mt-3 flex justify-between" }
const _hoisted_76 = { class: "block text-sm font-medium text-[#3c3c43] dark:text-gray-300 mb-2" }
const _hoisted_77 = { class: "space-y-3 border border-[#e5e5ea] dark:border-white/10 rounded-xl p-4 bg-white dark:bg-white/5" }
const _hoisted_78 = { class: "flex items-center gap-3" }
const _hoisted_79 = {
  for: "is_owner",
  class: "cursor-pointer text-sm text-[#1d1d1f] dark:text-white"
}
const _hoisted_80 = { class: "flex items-center gap-3" }
const _hoisted_81 = {
  for: "edit_all_leads",
  class: "cursor-pointer text-sm text-[#1d1d1f] dark:text-white"
}
const _hoisted_82 = { class: "flex items-center gap-3" }
const _hoisted_83 = {
  for: "view_all_leads",
  class: "cursor-pointer text-sm text-[#1d1d1f] dark:text-white"
}
const _hoisted_84 = { class: "flex items-center gap-3" }
const _hoisted_85 = {
  for: "can_invite_users",
  class: "cursor-pointer text-sm text-[#1d1d1f] dark:text-white"
}
const _hoisted_86 = { class: "flex items-center gap-3" }
const _hoisted_87 = {
  for: "view_all_calendars",
  class: "cursor-pointer text-sm text-[#1d1d1f] dark:text-white"
}
const _hoisted_88 = { class: "flex items-center justify-end gap-3 mt-8" }
const _hoisted_89 = ["disabled"]
const _hoisted_90 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_91 = { key: 1 }
const _hoisted_92 = {
  key: 1,
  class: "fixed inset-0 flex items-center justify-center z-50 px-4"
}
const _hoisted_93 = { class: "relative transform transition-all duration-300 scale-100 bg-white dark:bg-gray-900/95 backdrop-blur-[20px] shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25)] rounded-3xl p-8 w-full max-w-lg max-h-[90vh] overflow-y-auto mt-[100px] sm:mt-0" }
const _hoisted_94 = { class: "flex justify-between items-center mb-6" }
const _hoisted_95 = { class: "text-2xl font-semibold text-[#1d1d1f] dark:text-white" }
const _hoisted_96 = { class: "flex items-center gap-5 mb-8" }
const _hoisted_97 = { class: "text-xl font-semibold text-[#1d1d1f] dark:text-white" }
const _hoisted_98 = { class: "text-[#8e8e93] dark:text-gray-400" }
const _hoisted_99 = { class: "space-y-4" }
const _hoisted_100 = { class: "flex items-center gap-3" }
const _hoisted_101 = { class: "text-xs text-[#8e8e93] dark:text-gray-400" }
const _hoisted_102 = { class: "text-sm font-medium text-[#1d1d1f] dark:text-white" }
const _hoisted_103 = { class: "flex items-center gap-3" }
const _hoisted_104 = { class: "text-xs text-[#8e8e93] dark:text-gray-400" }
const _hoisted_105 = { class: "text-sm font-medium text-[#1d1d1f] dark:text-white" }
const _hoisted_106 = { class: "flex items-center gap-3" }
const _hoisted_107 = { class: "text-xs text-[#8e8e93] dark:text-gray-400" }
const _hoisted_108 = { class: "text-sm font-medium text-[#1d1d1f] dark:text-white" }
const _hoisted_109 = { class: "flex items-center gap-3" }
const _hoisted_110 = { class: "text-xs text-[#8e8e93] dark:text-gray-400" }
const _hoisted_111 = { class: "text-sm font-medium text-[#1d1d1f] dark:text-white" }
const _hoisted_112 = { class: "mt-6 pt-6 border-t border-gray-100 dark:border-white/10" }
const _hoisted_113 = { class: "text-sm font-medium text-[#3c3c43] dark:text-gray-300 mb-3" }
const _hoisted_114 = { class: "space-y-2" }
const _hoisted_115 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_116 = { class: "text-sm text-[#1d1d1f] dark:text-white" }
const _hoisted_117 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_118 = { class: "text-sm text-[#1d1d1f] dark:text-white" }
const _hoisted_119 = {
  key: 2,
  class: "flex items-center gap-2"
}
const _hoisted_120 = { class: "text-sm text-[#1d1d1f] dark:text-white" }
const _hoisted_121 = {
  key: 3,
  class: "flex items-center gap-2"
}
const _hoisted_122 = { class: "text-sm text-[#1d1d1f] dark:text-white" }
const _hoisted_123 = {
  key: 4,
  class: "flex items-center gap-2"
}
const _hoisted_124 = { class: "text-sm text-[#1d1d1f] dark:text-white" }
const _hoisted_125 = {
  key: 5,
  class: "flex items-center gap-2"
}
const _hoisted_126 = { class: "text-sm text-[#8e8e93] dark:text-gray-400" }
const _hoisted_127 = { class: "flex items-center justify-end gap-3 mt-8" }
const _hoisted_128 = {
  key: 2,
  class: "fixed inset-0 flex items-center justify-center z-50 px-4"
}
const _hoisted_129 = { class: "relative transform transition-all duration-300 scale-100 bg-white dark:bg-gray-900/95 backdrop-blur-[20px] shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25)] rounded-3xl p-8 w-full max-w-lg max-h-[90vh] overflow-y-auto mt-[100px] sm:mt-0" }
const _hoisted_130 = { class: "flex justify-between items-center mb-6" }
const _hoisted_131 = { class: "text-2xl font-semibold text-[#1d1d1f] dark:text-white" }
const _hoisted_132 = {
  key: 0,
  class: "mb-4 p-4 bg-[#FFE5E5] dark:bg-red-500/20 rounded-2xl"
}
const _hoisted_133 = { class: "text-[#FF3B30] font-medium" }
const _hoisted_134 = { class: "space-y-4" }
const _hoisted_135 = { class: "block text-sm font-medium text-[#3c3c43] dark:text-gray-300 mb-2" }
const _hoisted_136 = { class: "block text-sm font-medium text-[#3c3c43] dark:text-gray-300 mb-2" }
const _hoisted_137 = { class: "block text-sm font-medium text-[#3c3c43] dark:text-gray-300 mb-2" }
const _hoisted_138 = { class: "block text-sm font-medium text-[#3c3c43] dark:text-gray-300 mb-2" }
const _hoisted_139 = { class: "block text-sm font-medium text-[#3c3c43] dark:text-gray-300 mb-2" }
const _hoisted_140 = { class: "block text-sm font-medium text-[#3c3c43] dark:text-gray-300 mb-2" }
const _hoisted_141 = { value: "admin" }
const _hoisted_142 = { value: "editor" }
const _hoisted_143 = { value: "member" }
const _hoisted_144 = { value: "viewer" }
const _hoisted_145 = { class: "block text-sm font-medium text-[#3c3c43] dark:text-gray-300 mb-2" }
const _hoisted_146 = {
  key: 0,
  class: "text-center p-4"
}
const _hoisted_147 = { class: "text-[#8e8e93] dark:text-gray-400 mt-2" }
const _hoisted_148 = {
  key: 1,
  class: "p-4 bg-[#FFE5E5] dark:bg-red-500/20 rounded-xl"
}
const _hoisted_149 = { class: "text-[#FF3B30]" }
const _hoisted_150 = {
  key: 2,
  class: "max-h-60 overflow-y-auto border border-[#e5e5ea] dark:border-white/10 rounded-xl p-4 bg-white dark:bg-white/5"
}
const _hoisted_151 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_152 = ["id", "onUpdate:modelValue"]
const _hoisted_153 = ["for"]
const _hoisted_154 = { class: "mt-3 flex justify-between" }
const _hoisted_155 = { class: "block text-sm font-medium text-[#3c3c43] dark:text-gray-300 mb-2" }
const _hoisted_156 = { class: "space-y-3 border border-[#e5e5ea] dark:border-white/10 rounded-xl p-4 bg-white dark:bg-white/5" }
const _hoisted_157 = { class: "flex items-center gap-3" }
const _hoisted_158 = {
  for: "new_is_owner",
  class: "cursor-pointer text-sm text-[#1d1d1f] dark:text-white"
}
const _hoisted_159 = { class: "flex items-center gap-3" }
const _hoisted_160 = {
  for: "new_edit_all_leads",
  class: "cursor-pointer text-sm text-[#1d1d1f] dark:text-white"
}
const _hoisted_161 = { class: "flex items-center gap-3" }
const _hoisted_162 = {
  for: "new_view_all_leads",
  class: "cursor-pointer text-sm text-[#1d1d1f] dark:text-white"
}
const _hoisted_163 = { class: "flex items-center gap-3" }
const _hoisted_164 = {
  for: "new_can_invite_users",
  class: "cursor-pointer text-sm text-[#1d1d1f] dark:text-white"
}
const _hoisted_165 = { class: "flex items-center gap-3" }
const _hoisted_166 = {
  for: "new_view_all_calendars",
  class: "cursor-pointer text-sm text-[#1d1d1f] dark:text-white"
}
const _hoisted_167 = { class: "flex items-center justify-end gap-3 mt-8" }
const _hoisted_168 = ["disabled"]
const _hoisted_169 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_170 = { key: 1 }
const _hoisted_171 = {
  key: 3,
  class: "fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50"
}
const _hoisted_172 = { class: "bg-white dark:bg-[#1a1a1a] rounded-3xl shadow-2xl border border-[#E5E7EB] dark:border-[#374151] max-w-md w-full mx-4 overflow-hidden" }
const _hoisted_173 = { class: "bg-gradient-to-r from-[#FF3B30] to-[#FF2D92] p-6" }
const _hoisted_174 = { class: "flex items-center gap-4" }
const _hoisted_175 = { class: "text-xl font-bold text-white" }
const _hoisted_176 = { class: "text-white/80 text-sm" }
const _hoisted_177 = { class: "p-6" }
const _hoisted_178 = { class: "text-[#1a1a1a] dark:text-white text-center mb-6" }
const _hoisted_179 = { class: "flex gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.directT('modules.members.title')), 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.directT('modules.members.subTitle')), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportToExcel && _ctx.exportToExcel(...args))),
                class: "px-4 py-2.5 rounded-xl bg-gradient-to-r from-[#34C759] to-[#32D74B] text-white font-medium text-sm shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center gap-2"
              }, [
                _cache[41] || (_cache[41] = _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, "cloud_download", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.directT('modules.members.exportToExcel')), 1)
              ]),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showAddMemberModal && _ctx.showAddMemberModal(...args))),
                class: "px-4 py-2.5 rounded-xl bg-gradient-to-r from-[#007AFF] to-[#5856D6] text-white font-medium text-sm shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center gap-2"
              }, [
                _cache[42] || (_cache[42] = _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, "person_add", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.directT('modules.members.addMember')), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[43] || (_cache[43] = _createElementVNode("label", { class: "leading-none absolute ltr:left-[13px] rtl:right-[13px] text-[#8e8e93] dark:text-gray-400 mt-px top-1/2 -translate-y-1/2" }, [
              _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, "search")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery) = $event)),
              type: "text",
              placeholder: _ctx.directT('modules.members.searchMember'),
              class: "w-full px-4 py-3 ltr:pl-[38px] rtl:pr-[38px] bg-white dark:bg-white/5 shadow-[0_2px_8px_0_rgba(0,0,0,0.08)] border border-[#e5e5ea] dark:border-white/10 rounded-xl text-sm text-[#1d1d1f] dark:text-white placeholder-[#8e8e93] dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent focus:shadow-[0_4px_12px_0_rgba(0,122,255,0.15)] transition-all"
            }, null, 8, _hoisted_11), [
              [_vModelText, _ctx.searchQuery]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[44] || (_cache[44] = [
                _createElementVNode("div", { class: "relative" }, [
                  _createElementVNode("div", { class: "w-16 h-16 rounded-full border-4 border-gray-200 dark:border-gray-700" }),
                  _createElementVNode("div", { class: "w-16 h-16 rounded-full border-4 border-t-[#007AFF] animate-spin absolute top-0" })
                ], -1)
              ])))
            : (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _cache[45] || (_cache[45] = _createElementVNode("div", { class: "w-20 h-20 rounded-full bg-[#FF3B30]/10 flex items-center justify-center mx-auto mb-4" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-[40px] text-[#FF3B30]" }, "error")
                  ], -1)),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.error), 1)
                ]))
              : (_ctx.filteredMembers.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _cache[46] || (_cache[46] = _createElementVNode("div", { class: "w-20 h-20 rounded-full bg-[#f2f2f7] dark:bg-white/5 flex items-center justify-center mx-auto mb-4" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-[40px] text-[#8e8e93] dark:text-gray-400" }, "group_off")
                    ], -1)),
                    _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.directT('modules.members.noSuperAdminFound')), 1),
                    _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.directT('modules.members.noMembersFound')), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("table", _hoisted_21, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_22, [
                          _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.directT('modules.members.id')), 1),
                          _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.directT('modules.members.member')), 1),
                          _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.directT('modules.members.email')), 1),
                          _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.directT('modules.members.phone')), 1),
                          _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.directT('modules.members.location')), 1),
                          _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.directT('modules.members.joiningDate')), 1),
                          _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.directT('modules.members.lastActive')), 1),
                          _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.directT('modules.members.action')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", _hoisted_31, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedMembers, (member) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: member.id,
                            class: "hover:bg-[#f2f2f7] dark:hover:bg-white/5 transition-colors"
                          }, [
                            _createElementVNode("td", _hoisted_32, [
                              _createElementVNode("span", _hoisted_33, "#" + _toDisplayString(member.id.substring(0, 8).toUpperCase()), 1)
                            ]),
                            _createElementVNode("td", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                _cache[47] || (_cache[47] = _createElementVNode("div", { class: "w-10 h-10 rounded-full overflow-hidden bg-gradient-to-br from-[#007AFF] to-[#5856D6] flex items-center justify-center" }, [
                                  _createElementVNode("img", {
                                    src: _imports_0,
                                    class: "w-full h-full object-cover",
                                    alt: "user-image"
                                  })
                                ], -1)),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_36, _toDisplayString(member.name), 1),
                                  _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.getRoleName(member.role)), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_38, _toDisplayString(member.email), 1),
                            _createElementVNode("td", _hoisted_39, _toDisplayString(member.phone), 1),
                            _createElementVNode("td", _hoisted_40, _toDisplayString(member.location), 1),
                            _createElementVNode("td", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _cache[48] || (_cache[48] = _createElementVNode("div", { class: "w-8 h-8 rounded-lg bg-gradient-to-br from-[#34C759] to-[#32D74B] flex items-center justify-center" }, [
                                  _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[16px]" }, "calendar_today")
                                ], -1)),
                                _createTextVNode(" " + _toDisplayString(member.joiningDate), 1)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_43, [
                              _createElementVNode("span", _hoisted_44, _toDisplayString(member.lastActive), 1)
                            ]),
                            _createElementVNode("td", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.viewMember(member)),
                                  class: "w-8 h-8 rounded-full bg-[#007AFF] text-white flex items-center justify-center transition-all hover:scale-110 hover:shadow-lg"
                                }, _cache[49] || (_cache[49] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined !text-[18px]" }, "visibility", -1)
                                ]), 8, _hoisted_47),
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.showEditMember(member)),
                                  class: "w-8 h-8 rounded-full bg-[#5856D6] text-white flex items-center justify-center transition-all hover:scale-110 hover:shadow-lg"
                                }, _cache[50] || (_cache[50] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined !text-[18px]" }, "edit", -1)
                                ]), 8, _hoisted_48),
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.confirmDelete(member)),
                                  class: "w-8 h-8 rounded-full bg-[#FF3B30] text-white flex items-center justify-center transition-all hover:scale-110 hover:shadow-lg"
                                }, _cache[51] || (_cache[51] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined !text-[18px]" }, "delete", -1)
                                ]), 8, _hoisted_49)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])),
          _createVNode(_component_Pagination, {
            items: _ctx.itemsPerPage,
            total: _ctx.filteredMembers.length,
            "current-page": _ctx.currentPage,
            onChangePage: _ctx.changePage,
            class: "px-6 py-4 border-t border-gray-100 dark:border-white/10"
          }, null, 8, ["items", "total", "current-page", "onChangePage"])
        ])
      ])
    ]),
    (_ctx.showEditModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/60 backdrop-blur-sm",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
          }),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("h3", _hoisted_53, _toDisplayString(_ctx.directT('modules.members.editMember')), 1),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args))),
                class: "w-10 h-10 rounded-full bg-[#f2f2f7] dark:bg-white/10 flex items-center justify-center hover:bg-[#e5e5ea] dark:hover:bg-white/20 transition-colors"
              }, _cache[52] || (_cache[52] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-[#3c3c43] dark:text-gray-300" }, "close", -1)
              ]))
            ]),
            (_ctx.editError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.editError), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("form", {
              onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveEdit && _ctx.saveEdit(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.directT('modules.members.name')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editingMember.name) = $event)),
                    type: "text",
                    class: "w-full px-4 py-3 bg-white dark:bg-white/5 border border-[#e5e5ea] dark:border-white/10 rounded-xl text-sm text-[#1d1d1f] dark:text-white focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.editingMember.name]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.directT('modules.members.phone')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editingMember.phone) = $event)),
                    type: "text",
                    class: "w-full px-4 py-3 bg-white dark:bg-white/5 border border-[#e5e5ea] dark:border-white/10 rounded-xl text-sm text-[#1d1d1f] dark:text-white focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all"
                  }, null, 512), [
                    [_vModelText, _ctx.editingMember.phone]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.directT('modules.members.location')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editingMember.location) = $event)),
                    type: "text",
                    class: "w-full px-4 py-3 bg-white dark:bg-white/5 border border-[#e5e5ea] dark:border-white/10 rounded-xl text-sm text-[#1d1d1f] dark:text-white focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all"
                  }, null, 512), [
                    [_vModelText, _ctx.editingMember.location]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.directT('modules.members.role')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editingMember.role) = $event)),
                    class: "w-full px-4 py-3 bg-white dark:bg-white/5 border border-[#e5e5ea] dark:border-white/10 rounded-xl text-sm text-[#1d1d1f] dark:text-white focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all"
                  }, [
                    _createElementVNode("option", _hoisted_61, _toDisplayString(_ctx.directT('modules.members.superadmin') || 'Super Admin'), 1),
                    _createElementVNode("option", _hoisted_62, _toDisplayString(_ctx.directT('modules.members.admin')), 1),
                    _createElementVNode("option", _hoisted_63, _toDisplayString(_ctx.directT('modules.members.editor')), 1),
                    _createElementVNode("option", _hoisted_64, _toDisplayString(_ctx.directT('modules.members.member')), 1),
                    _createElementVNode("option", _hoisted_65, _toDisplayString(_ctx.directT('modules.members.viewer')), 1)
                  ], 512), [
                    [_vModelSelect, _ctx.editingMember.role]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.directT('modules.members.screenPermissions')), 1),
                  (_ctx.loadingScreens)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                        _cache[53] || (_cache[53] = _createElementVNode("div", { class: "w-8 h-8 border-2 border-[#007AFF] border-t-transparent rounded-full animate-spin mx-auto" }, null, -1)),
                        _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.directT('modules.members.loadingScreens')), 1)
                      ]))
                    : (_ctx.screenError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                          _createElementVNode("p", _hoisted_70, _toDisplayString(_ctx.screenError), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.screens, (screen) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: screen.screen_key,
                                class: "flex items-center gap-2 p-2 hover:bg-[#f2f2f7] dark:hover:bg-white/5 rounded-lg transition-colors"
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  id: `screen_${screen.screen_key}`,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.screenPermissions[screen.screen_key]) = $event),
                                  class: "w-4 h-4 text-[#007AFF] bg-white dark:bg-white/10 border-[#e5e5ea] dark:border-white/20 rounded focus:ring-[#007AFF] focus:ring-2"
                                }, null, 8, _hoisted_73), [
                                  [_vModelCheckbox, _ctx.screenPermissions[screen.screen_key]]
                                ]),
                                _createElementVNode("label", {
                                  for: `screen_${screen.screen_key}`,
                                  class: "cursor-pointer text-sm text-[#1d1d1f] dark:text-white"
                                }, _toDisplayString(screen.display_name), 9, _hoisted_74)
                              ]))
                            }), 128))
                          ])
                        ])),
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectAllScreens(true))),
                      class: "text-xs text-[#007AFF] hover:underline font-medium"
                    }, _toDisplayString(_ctx.directT('modules.members.selectAll')), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectAllScreens(false))),
                      class: "text-xs text-[#8e8e93] hover:text-[#3c3c43] dark:text-gray-400 dark:hover:text-gray-300"
                    }, _toDisplayString(_ctx.directT('modules.members.deselectAll')), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.directT('modules.members.additionalPermissions')), 1),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "is_owner",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editingMember.permissions.is_owner) = $event)),
                        class: "w-4 h-4 text-[#007AFF] bg-white dark:bg-white/10 border-[#e5e5ea] dark:border-white/20 rounded focus:ring-[#007AFF] focus:ring-2"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.editingMember.permissions.is_owner]
                      ]),
                      _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.directT('modules.members.organizationOwner')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "edit_all_leads",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editingMember.permissions.edit_all_leads) = $event)),
                        class: "w-4 h-4 text-[#007AFF] bg-white dark:bg-white/10 border-[#e5e5ea] dark:border-white/20 rounded focus:ring-[#007AFF] focus:ring-2"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.editingMember.permissions.edit_all_leads]
                      ]),
                      _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.directT('modules.members.editAllLeads')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "view_all_leads",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editingMember.permissions.view_all_leads) = $event)),
                        class: "w-4 h-4 text-[#007AFF] bg-white dark:bg-white/10 border-[#e5e5ea] dark:border-white/20 rounded focus:ring-[#007AFF] focus:ring-2"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.editingMember.permissions.view_all_leads]
                      ]),
                      _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.directT('modules.members.viewAllLeads')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "can_invite_users",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editingMember.permissions.can_invite_users) = $event)),
                        class: "w-4 h-4 text-[#007AFF] bg-white dark:bg-white/10 border-[#e5e5ea] dark:border-white/20 rounded focus:ring-[#007AFF] focus:ring-2"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.editingMember.permissions.can_invite_users]
                      ]),
                      _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.directT('modules.members.canInviteUsers')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_86, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "view_all_calendars",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editingMember.permissions.view_all_calendars) = $event)),
                        class: "w-4 h-4 text-[#007AFF] bg-white dark:bg-white/10 border-[#e5e5ea] dark:border-white/20 rounded focus:ring-[#007AFF] focus:ring-2"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.editingMember.permissions.view_all_calendars]
                      ]),
                      _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.directT('modules.members.viewAllCalendars')), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args))),
                  class: "px-6 py-3 rounded-2xl font-medium transition-all bg-[#f2f2f7] dark:bg-white/10 text-[#1d1d1f] dark:text-white hover:bg-[#e5e5ea] dark:hover:bg-white/20"
                }, _toDisplayString(_ctx.directT('modules.members.cancel')), 1),
                _createElementVNode("button", {
                  type: "submit",
                  class: "px-6 py-3 rounded-2xl font-medium transition-all bg-gradient-to-r from-[#007AFF] to-[#5856D6] text-white shadow-md hover:shadow-lg transform hover:scale-105",
                  disabled: _ctx.saving
                }, [
                  (_ctx.saving)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_90, [
                        _cache[54] || (_cache[54] = _createElementVNode("div", { class: "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.directT('modules.members.saving')), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_91, _toDisplayString(_ctx.directT('modules.members.save')), 1))
                ], 8, _hoisted_89)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showViewModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/60 backdrop-blur-sm",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showViewModal = false))
          }),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("h3", _hoisted_95, _toDisplayString(_ctx.directT('modules.members.memberDetails')), 1),
              _createElementVNode("button", {
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showViewModal = false)),
                class: "w-10 h-10 rounded-full bg-[#f2f2f7] dark:bg-white/10 flex items-center justify-center hover:bg-[#e5e5ea] dark:hover:bg-white/20 transition-colors"
              }, _cache[55] || (_cache[55] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-[#3c3c43] dark:text-gray-300" }, "close", -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_96, [
              _cache[56] || (_cache[56] = _createElementVNode("div", { class: "w-24 h-24 rounded-full overflow-hidden bg-gradient-to-br from-[#007AFF] to-[#5856D6] flex items-center justify-center shadow-lg" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "w-full h-full object-cover",
                  alt: ""
                })
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("h4", _hoisted_97, _toDisplayString(_ctx.viewingMember.name), 1),
                _createElementVNode("p", _hoisted_98, _toDisplayString(_ctx.viewingMember.email), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-block px-3 py-1 mt-2 text-xs font-medium rounded-full", {
              'bg-gradient-to-r from-[#34C759] to-[#32D74B] text-white': _ctx.viewingMember.role === 'admin',
              'bg-gradient-to-r from-[#007AFF] to-[#5856D6] text-white': _ctx.viewingMember.role === 'editor',
              'bg-gradient-to-r from-[#AF52DE] to-[#5E5CE6] text-white': _ctx.viewingMember.role === 'member',
              'bg-[#8e8e93]/20 text-[#8e8e93] dark:text-gray-400': _ctx.viewingMember.role === 'viewer'
              }])
                }, _toDisplayString(_ctx.getRoleName(_ctx.viewingMember.role)), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("div", _hoisted_100, [
                _cache[57] || (_cache[57] = _createElementVNode("div", { class: "w-10 h-10 rounded-xl bg-gradient-to-br from-[#007AFF] to-[#5856D6] flex items-center justify-center shadow-md" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[20px]" }, "call")
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_101, _toDisplayString(_ctx.directT('modules.members.phone')), 1),
                  _createElementVNode("div", _hoisted_102, _toDisplayString(_ctx.viewingMember.phone), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_103, [
                _cache[58] || (_cache[58] = _createElementVNode("div", { class: "w-10 h-10 rounded-xl bg-gradient-to-br from-[#FF9500] to-[#FF6200] flex items-center justify-center shadow-md" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[20px]" }, "location_on")
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_104, _toDisplayString(_ctx.directT('modules.members.location')), 1),
                  _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.viewingMember.location), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_106, [
                _cache[59] || (_cache[59] = _createElementVNode("div", { class: "w-10 h-10 rounded-xl bg-gradient-to-br from-[#34C759] to-[#32D74B] flex items-center justify-center shadow-md" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[20px]" }, "event")
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.directT('modules.members.joiningDate')), 1),
                  _createElementVNode("div", _hoisted_108, _toDisplayString(_ctx.viewingMember.joiningDate), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_109, [
                _cache[60] || (_cache[60] = _createElementVNode("div", { class: "w-10 h-10 rounded-xl bg-gradient-to-br from-[#5856D6] to-[#AF52DE] flex items-center justify-center shadow-md" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[20px]" }, "history")
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.directT('modules.members.lastActive')), 1),
                  _createElementVNode("div", _hoisted_111, _toDisplayString(_ctx.viewingMember.lastActive), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_112, [
                _createElementVNode("h5", _hoisted_113, _toDisplayString(_ctx.directT('modules.members.additionalPermissions')), 1),
                _createElementVNode("div", _hoisted_114, [
                  (_ctx.viewingMember.permissions.is_owner)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                        _cache[61] || (_cache[61] = _createElementVNode("div", { class: "w-5 h-5 rounded-full bg-[#34C759] flex items-center justify-center" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[14px]" }, "check")
                        ], -1)),
                        _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.directT('modules.members.organizationOwner')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.viewingMember.permissions.edit_all_leads)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                        _cache[62] || (_cache[62] = _createElementVNode("div", { class: "w-5 h-5 rounded-full bg-[#34C759] flex items-center justify-center" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[14px]" }, "check")
                        ], -1)),
                        _createElementVNode("div", _hoisted_118, _toDisplayString(_ctx.directT('modules.members.editAllLeads')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.viewingMember.permissions.view_all_leads)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                        _cache[63] || (_cache[63] = _createElementVNode("div", { class: "w-5 h-5 rounded-full bg-[#34C759] flex items-center justify-center" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[14px]" }, "check")
                        ], -1)),
                        _createElementVNode("div", _hoisted_120, _toDisplayString(_ctx.directT('modules.members.viewAllLeads')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.viewingMember.permissions.can_invite_users)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                        _cache[64] || (_cache[64] = _createElementVNode("div", { class: "w-5 h-5 rounded-full bg-[#34C759] flex items-center justify-center" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[14px]" }, "check")
                        ], -1)),
                        _createElementVNode("div", _hoisted_122, _toDisplayString(_ctx.directT('modules.members.canInviteUsers')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.viewingMember.permissions.view_all_calendars)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                        _cache[65] || (_cache[65] = _createElementVNode("div", { class: "w-5 h-5 rounded-full bg-[#34C759] flex items-center justify-center" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[14px]" }, "check")
                        ], -1)),
                        _createElementVNode("div", _hoisted_124, _toDisplayString(_ctx.directT('modules.members.viewAllCalendars')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.viewingMember.permissions.is_owner && !_ctx.viewingMember.permissions.edit_all_leads && !_ctx.viewingMember.permissions.view_all_leads && !_ctx.viewingMember.permissions.can_invite_users && !_ctx.viewingMember.permissions.view_all_calendars)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                        _createElementVNode("div", _hoisted_126, _toDisplayString(_ctx.directT('modules.members.noAdditionalPermissions')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_127, [
              _createElementVNode("button", {
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showViewModal = false)),
                class: "px-6 py-3 rounded-2xl font-medium transition-all bg-[#f2f2f7] dark:bg-white/10 text-[#1d1d1f] dark:text-white hover:bg-[#e5e5ea] dark:hover:bg-white/20"
              }, _toDisplayString(_ctx.directT('modules.members.close')), 1),
              _createElementVNode("button", {
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.showEditForViewing && _ctx.showEditForViewing(...args))),
                class: "px-6 py-3 rounded-2xl font-medium transition-all bg-gradient-to-r from-[#007AFF] to-[#5856D6] text-white shadow-md hover:shadow-lg transform hover:scale-105"
              }, _toDisplayString(_ctx.directT('modules.members.edit')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showAddModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/60 backdrop-blur-sm",
            onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.cancelAdd && _ctx.cancelAdd(...args)))
          }),
          _createElementVNode("div", _hoisted_129, [
            _createElementVNode("div", _hoisted_130, [
              _createElementVNode("h3", _hoisted_131, _toDisplayString(_ctx.directT('modules.members.addNewMember')), 1),
              _createElementVNode("button", {
                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.cancelAdd && _ctx.cancelAdd(...args))),
                class: "w-10 h-10 rounded-full bg-[#f2f2f7] dark:bg-white/10 flex items-center justify-center hover:bg-[#e5e5ea] dark:hover:bg-white/20 transition-colors"
              }, _cache[66] || (_cache[66] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-[#3c3c43] dark:text-gray-300" }, "close", -1)
              ]))
            ]),
            (_ctx.addError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                  _createElementVNode("p", _hoisted_133, _toDisplayString(_ctx.addError), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("form", {
              onSubmit: _cache[38] || (_cache[38] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addNewMember && _ctx.addNewMember(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_134, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_135, _toDisplayString(_ctx.directT('modules.members.name')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.newMember.name) = $event)),
                    type: "text",
                    class: "w-full px-4 py-3 bg-white dark:bg-white/5 border border-[#e5e5ea] dark:border-white/10 rounded-xl text-sm text-[#1d1d1f] dark:text-white focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.newMember.name]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_136, _toDisplayString(_ctx.directT('modules.members.email')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.newMember.email) = $event)),
                    type: "email",
                    class: "w-full px-4 py-3 bg-white dark:bg-white/5 border border-[#e5e5ea] dark:border-white/10 rounded-xl text-sm text-[#1d1d1f] dark:text-white focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.newMember.email]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_137, _toDisplayString(_ctx.directT('modules.members.password')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.newMember.password) = $event)),
                    type: "password",
                    class: "w-full px-4 py-3 bg-white dark:bg-white/5 border border-[#e5e5ea] dark:border-white/10 rounded-xl text-sm text-[#1d1d1f] dark:text-white focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.newMember.password]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_138, _toDisplayString(_ctx.directT('modules.members.phone')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.newMember.phone) = $event)),
                    type: "text",
                    class: "w-full px-4 py-3 bg-white dark:bg-white/5 border border-[#e5e5ea] dark:border-white/10 rounded-xl text-sm text-[#1d1d1f] dark:text-white focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all"
                  }, null, 512), [
                    [_vModelText, _ctx.newMember.phone]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_139, _toDisplayString(_ctx.directT('modules.members.location')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.newMember.location) = $event)),
                    type: "text",
                    class: "w-full px-4 py-3 bg-white dark:bg-white/5 border border-[#e5e5ea] dark:border-white/10 rounded-xl text-sm text-[#1d1d1f] dark:text-white focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all"
                  }, null, 512), [
                    [_vModelText, _ctx.newMember.location]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_140, _toDisplayString(_ctx.directT('modules.members.role')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.newMember.role) = $event)),
                    class: "w-full px-4 py-3 bg-white dark:bg-white/5 border border-[#e5e5ea] dark:border-white/10 rounded-xl text-sm text-[#1d1d1f] dark:text-white focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all"
                  }, [
                    _createElementVNode("option", _hoisted_141, _toDisplayString(_ctx.directT('modules.members.admin')), 1),
                    _createElementVNode("option", _hoisted_142, _toDisplayString(_ctx.directT('modules.members.editor')), 1),
                    _createElementVNode("option", _hoisted_143, _toDisplayString(_ctx.directT('modules.members.member')), 1),
                    _createElementVNode("option", _hoisted_144, _toDisplayString(_ctx.directT('modules.members.viewer')), 1)
                  ], 512), [
                    [_vModelSelect, _ctx.newMember.role]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_145, _toDisplayString(_ctx.directT('modules.members.screenPermissions')), 1),
                  (_ctx.loadingScreens)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                        _cache[67] || (_cache[67] = _createElementVNode("div", { class: "w-8 h-8 border-2 border-[#007AFF] border-t-transparent rounded-full animate-spin mx-auto" }, null, -1)),
                        _createElementVNode("p", _hoisted_147, _toDisplayString(_ctx.directT('modules.members.loadingScreens')), 1)
                      ]))
                    : (_ctx.screenError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                          _createElementVNode("p", _hoisted_149, _toDisplayString(_ctx.screenError), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_150, [
                          _createElementVNode("div", _hoisted_151, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.screens, (screen) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: screen.screen_key,
                                class: "flex items-center gap-2 p-2 hover:bg-[#f2f2f7] dark:hover:bg-white/5 rounded-lg transition-colors"
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  id: `new_screen_${screen.screen_key}`,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.newScreenPermissions[screen.screen_key]) = $event),
                                  class: "w-4 h-4 text-[#007AFF] bg-white dark:bg-white/10 border-[#e5e5ea] dark:border-white/20 rounded focus:ring-[#007AFF] focus:ring-2"
                                }, null, 8, _hoisted_152), [
                                  [_vModelCheckbox, _ctx.newScreenPermissions[screen.screen_key]]
                                ]),
                                _createElementVNode("label", {
                                  for: `new_screen_${screen.screen_key}`,
                                  class: "cursor-pointer text-sm text-[#1d1d1f] dark:text-white"
                                }, _toDisplayString(screen.display_name), 9, _hoisted_153)
                              ]))
                            }), 128))
                          ])
                        ])),
                  _createElementVNode("div", _hoisted_154, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.selectAllNewScreens(true))),
                      class: "text-xs text-[#007AFF] hover:underline font-medium"
                    }, _toDisplayString(_ctx.directT('modules.members.selectAll')), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.selectAllNewScreens(false))),
                      class: "text-xs text-[#8e8e93] hover:text-[#3c3c43] dark:text-gray-400 dark:hover:text-gray-300"
                    }, _toDisplayString(_ctx.directT('modules.members.deselectAll')), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_155, _toDisplayString(_ctx.directT('modules.members.additionalPermissions')), 1),
                  _createElementVNode("div", _hoisted_156, [
                    _createElementVNode("div", _hoisted_157, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "new_is_owner",
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.newMember.permissions.is_owner) = $event)),
                        class: "w-4 h-4 text-[#007AFF] bg-white dark:bg-white/10 border-[#e5e5ea] dark:border-white/20 rounded focus:ring-[#007AFF] focus:ring-2"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.newMember.permissions.is_owner]
                      ]),
                      _createElementVNode("label", _hoisted_158, _toDisplayString(_ctx.directT('modules.members.organizationOwner')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_159, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "new_edit_all_leads",
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.newMember.permissions.edit_all_leads) = $event)),
                        class: "w-4 h-4 text-[#007AFF] bg-white dark:bg-white/10 border-[#e5e5ea] dark:border-white/20 rounded focus:ring-[#007AFF] focus:ring-2"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.newMember.permissions.edit_all_leads]
                      ]),
                      _createElementVNode("label", _hoisted_160, _toDisplayString(_ctx.directT('modules.members.editAllLeads')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_161, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "new_view_all_leads",
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.newMember.permissions.view_all_leads) = $event)),
                        class: "w-4 h-4 text-[#007AFF] bg-white dark:bg-white/10 border-[#e5e5ea] dark:border-white/20 rounded focus:ring-[#007AFF] focus:ring-2"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.newMember.permissions.view_all_leads]
                      ]),
                      _createElementVNode("label", _hoisted_162, _toDisplayString(_ctx.directT('modules.members.viewAllLeads')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_163, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "new_can_invite_users",
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.newMember.permissions.can_invite_users) = $event)),
                        class: "w-4 h-4 text-[#007AFF] bg-white dark:bg-white/10 border-[#e5e5ea] dark:border-white/20 rounded focus:ring-[#007AFF] focus:ring-2"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.newMember.permissions.can_invite_users]
                      ]),
                      _createElementVNode("label", _hoisted_164, _toDisplayString(_ctx.directT('modules.members.canInviteUsers')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_165, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "new_view_all_calendars",
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.newMember.permissions.view_all_calendars) = $event)),
                        class: "w-4 h-4 text-[#007AFF] bg-white dark:bg-white/10 border-[#e5e5ea] dark:border-white/20 rounded focus:ring-[#007AFF] focus:ring-2"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.newMember.permissions.view_all_calendars]
                      ]),
                      _createElementVNode("label", _hoisted_166, _toDisplayString(_ctx.directT('modules.members.viewAllCalendars')), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_167, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.cancelAdd && _ctx.cancelAdd(...args))),
                  class: "px-6 py-3 rounded-2xl font-medium transition-all bg-[#f2f2f7] dark:bg-white/10 text-[#1d1d1f] dark:text-white hover:bg-[#e5e5ea] dark:hover:bg-white/20"
                }, _toDisplayString(_ctx.directT('modules.members.cancel')), 1),
                _createElementVNode("button", {
                  type: "submit",
                  class: "px-6 py-3 rounded-2xl font-medium transition-all bg-gradient-to-r from-[#007AFF] to-[#5856D6] text-white shadow-md hover:shadow-lg transform hover:scale-105",
                  disabled: _ctx.addingSaving
                }, [
                  (_ctx.addingSaving)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_169, [
                        _cache[68] || (_cache[68] = _createElementVNode("div", { class: "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.directT('modules.members.adding')), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_170, _toDisplayString(_ctx.directT('modules.members.addMember')), 1))
                ], 8, _hoisted_168)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDeletePopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_171, [
          _createElementVNode("div", _hoisted_172, [
            _createElementVNode("div", _hoisted_173, [
              _createElementVNode("div", _hoisted_174, [
                _cache[69] || (_cache[69] = _createElementVNode("div", { class: "w-12 h-12 bg-white/20 rounded-2xl flex items-center justify-center" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-white text-xl" }, "delete")
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_175, _toDisplayString(_ctx.directT('modules.members.deleteConfirmTitle')), 1),
                  _createElementVNode("p", _hoisted_176, _toDisplayString(_ctx.directT('modules.members.deleteConfirmSubtitle')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_177, [
              _createElementVNode("p", _hoisted_178, _toDisplayString(_ctx.directT('modules.members.deleteConfirmMessage').replace('{memberName}', _ctx.memberToDelete?.name || '')), 1),
              _createElementVNode("div", _hoisted_179, [
                _createElementVNode("button", {
                  onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args))),
                  class: "flex-1 px-4 py-3 bg-[#F3F4F6] dark:bg-[#374151] text-[#1a1a1a] dark:text-white font-medium rounded-2xl transition-all duration-200 hover:bg-[#E5E7EB] dark:hover:bg-[#4B5563]"
                }, _toDisplayString(_ctx.directT('modules.members.cancel')), 1),
                _createElementVNode("button", {
                  onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.confirmDeleteAction && _ctx.confirmDeleteAction(...args))),
                  class: "flex-1 px-4 py-3 bg-gradient-to-r from-[#FF3B30] to-[#FF2D92] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#E6342A] hover:to-[#E6297D] shadow-lg"
                }, _toDisplayString(_ctx.directT('modules.members.delete')), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}